import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";

const links = [
  { id: "services", label: "Services" },
  { id: "realisations", label: "Réalisations" },
  { id: "process", label: "Processus" },
  { id: "partenaires", label: "Partenaires" },
  { id: "cibles", label: "Pour qui" },
  { id: "contact", label: "Contact" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  const isHome = pathname === "/";

  // Build hash link that works from any route (home + anchor)
  const hashHref = (id) => (isHome ? `#${id}` : `/#${id}`);
  const homeHref = isHome ? "#top" : "/";

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#0A0A0A]/85 backdrop-blur-xl border-b border-white/10"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 flex items-center justify-between h-20">
        <a
          href={homeHref}
          data-testid="navbar-logo"
          aria-label="PDR France - Accueil"
          className="flex items-center gap-3 group"
        >
          <img
            src="/assets/logo-pdr-france.jpeg"
            alt="PDR France"
            className="h-12 w-12 object-cover rounded-sm border border-white/10 group-hover:border-white/30 transition-colors"
          />
          <div className="hidden sm:flex flex-col leading-none">
            <span className="font-heading text-base font-black uppercase tracking-[0.15em]">
              PDR <span className="text-[#EF4135]">FRANCE</span>
            </span>
            <span className="text-[9px] uppercase tracking-[0.3em] text-white/50 mt-1">
              Débosselage sans peinture
            </span>
          </div>
        </a>

        <nav className="hidden lg:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.id}
              href={hashHref(l.id)}
              data-testid={`nav-link-${l.id}`}
              className="text-sm font-medium text-white/70 hover:text-white uppercase tracking-wider transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <a
            href="tel:+33773119016"
            data-testid="nav-phone"
            className="flex items-center gap-2 text-sm font-semibold text-white/80 hover:text-white"
          >
            <Phone className="w-4 h-4" />
            <span>Appel direct</span>
          </a>
          <a
            href={hashHref("contact")}
            data-testid="nav-cta-devis"
            className="bg-[#007AFF] hover:bg-[#3B82F6] text-white text-xs font-bold uppercase tracking-widest px-6 py-3 transition-colors"
          >
            Devis gratuit
          </a>
        </div>

        <button
          onClick={() => setOpen(!open)}
          data-testid="navbar-mobile-toggle"
          className="lg:hidden p-2 text-white"
          aria-label="Menu"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div
          data-testid="navbar-mobile-menu"
          className="lg:hidden bg-[#0A0A0A]/95 backdrop-blur-xl border-t border-white/10 px-6 py-6 flex flex-col gap-4"
        >
          {links.map((l) => (
            <a
              key={l.id}
              href={hashHref(l.id)}
              onClick={() => setOpen(false)}
              className="text-sm font-medium text-white/80 uppercase tracking-wider"
            >
              {l.label}
            </a>
          ))}
          <a
            href={hashHref("contact")}
            onClick={() => setOpen(false)}
            className="bg-[#007AFF] text-white text-xs font-bold uppercase tracking-widest px-6 py-3 text-center mt-2"
          >
            Devis gratuit
          </a>
        </div>
      )}
    </header>
  );
};
